import { render } from "./NotificationRenew.vue?vue&type=template&id=33724b90&scoped=true"
import script from "./NotificationRenew.vue?vue&type=script&lang=js"
export * from "./NotificationRenew.vue?vue&type=script&lang=js"

import "./NotificationRenew.vue?vue&type=style&index=0&id=33724b90&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33724b90"]])

export default __exports__